<template>
  <v-container>
    <!-- Lift Overview -->
    <div class="mb-8">
      <v-card class="mb-4">
        <v-card-title class="primary white--text">
          <span class="white--text">Lift Overview</span>
        </v-card-title>
      </v-card>

      <v-row class="px-4">
        <v-col cols="12"
               sm="6"
               md="6"
               lg="3"
               v-for="item in liftOverviewItems"
               :key="item.values.name">
          <v-card>
            <v-card-title :class="`justify-center text-h4 ${item.className}`">
              {{ item.values.completed }} / {{ item.values.total }}
            </v-card-title>
            <v-divider :class="`mx-8 divider-${item.className}`" />
            <v-card-subtitle :class="`d-flex text-start text-h6 ${item.className}`">
              <CargoFlagIcon :flagType="item.className"
                             size="30"
                             class="mx-1" />
              {{ item.values.name }}

              <v-spacer />

              <span v-if="item.showROB">ROB: {{ item.values.robTotal }}</span>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!-- Lift Overview End -->
    <!-- Cargo List Start -->
    <div>
      <v-card class="mb-4">
        <v-card-title class="primary white--text">
          <span class="white--text">Cargo Lines</span>
        </v-card-title>
      </v-card>
      <v-data-table :items="voyageCargo"
                    :item-class="rowClasses"
                    :headers="cargoLineHeaders"
                    :no-data-text="`No Cargo Lines found for Voyage No: ${voyageData.voyageNo}`"
                    :mobile-breakpoint="dataTableMobileBreakpoint"
                    :items-per-page="-1">
        <template v-slot:item.width="{ item }">
          <span>{{ item.width | roundNumbers }}</span>
        </template>
        <template v-slot:item.length="{ item }">
          <span>{{ item.length | roundNumbers }}</span>
        </template>
        <template v-slot:item.offshoreLiftTime="{ item }">
          <span>
            {{
            item.offshoreLiftTime | removeTAndSecondsAndFormatDate
            }}
          </span>
        </template>
        <template v-slot:item.markedAsLifted="{ item }">
          <span v-if="item.markedAsLifted">
            <v-icon :size="iconSize" color="green">mdi-check-circle</v-icon>
          </span>
        </template>
        <template v-slot:item.badges="{ item }">
          <div class="d-flex">
            <CargoFlagIcon v-for="flag in getFlagsForCargoLineItem(item)"
                           :key="flag"
                           :flagType="flag"
                           size="30"
                           class="mx-1" />
          </div>
        </template>
      </v-data-table>
    </div>
    <!-- Cargo List End -->
  </v-container>
</template>

<script>
  import CargoFlagIcon from './CargoFlagIcon.vue';
  import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';
  import { mapState, mapGetters } from 'vuex';


  export default {
    name: 'VoyageCargoCardNew',
    props: {
      direction: String,
      voyageData: Object,
      voyageNumber: String,
      barColour: String,
    },
    components: { CargoFlagIcon },
    mixins: [ResponsiveSizeHelperMixin],
    data() {
      return {
        cargoLineHeaders: [
          { text: 'Asset', value: 'destination' },
          { text: 'Unit Id', value: 'unitId' },
          { text: 'Description', value: 'description' },
          { text: 'Vendor', value: 'vendor' },
          { text: 'Weight (Kg)', value: 'weightKg' },
          { text: 'Lifted Weight', value: 'liftedWeight' },
          { text: 'DG Class', value: 'dgSubClass' },
          { text: 'UN Number', value: 'unNo' },
          { text: `Width (${this.voyageData.areSizesInMetres ? 'm' : 'ft'})`, value: 'width' },
          { text: `Length (${this.voyageData.areSizesInMetres ? 'm' : 'ft'})`, value: 'length' },
          { text: this.direction === "Outbound" ? 'Delivered at' : 'Received at', value: 'offshoreLiftTime' },
          { text: 'Lifted', value: 'markedAsLifted' },
          { text: '', value: 'badges' },
        ],
      };
    },
    computed: {
      ...mapState(['voyageReportsStore']),
      ...mapGetters({
        getSyncedAndUnsyncedCargoForVoyage: 'voyageReportsStore/getSyncedAndUnSyncedCargoForVoyage',
      }),
      liftOverviewItems() {
        const items = [
          {
            values: this.voyageData.overallLifts,
            icon: 'mdi-arrow-up-bold',
            className: 'lift',
            showROB: true,
          },
          { values: this.voyageData.priorityLifts, icon: 'mdi-currency-gbp', className: 'priority' },
          { values: this.voyageData.heavyLifts, icon: 'mdi-weight', className: 'heavy' },
          { values: this.voyageData.dangerousLifts, icon: 'mdi-exclamation-thick', className: 'dangerous' },
        ];
        return items;
      },
      voyageCargo() {
        return this.getSyncedAndUnsyncedCargoForVoyage(this.direction.toLowerCase() === 'outbound');
      },
      feetOrMetres() {
        return this.voyageData.areSizesInMetres ? 'm' : 'ft';
      },
    },
    methods: {
      getFlagsForCargoLineItem(cargoLine) {
        const flags = [];
        if (cargoLine.isDangerousGoods) flags.push('dangerous');
        if (cargoLine.isHeavyLift) flags.push('heavy');
        if (cargoLine.highPriority) flags.push('priority');
        return flags;
      },
      isNob(cargoLine) {
        return cargoLine.isNob ? 'is-nob' : '';
      },
      isExtra(cargoLine) {
        return cargoLine.isExtra ? 'is-extra' : '';
      },
      rowClasses(cargoline) {
        var classes = [];
        classes.push(this.isNob(cargoline));
        classes.push(this.isExtra(cargoline));
        return classes;
      }
    },
  };
</script>

<style>
  .solid-border {
    border: 2px solid;
  }

  .lift {
    color: #61bbc5 !important;
    border-color: #61bbc5;
  }

  .priority {
    color: #ea93fa !important;
    border-color: #ea93fa;
  }

  .heavy {
    color: #fbba00 !important;
    border-color: #fbba00;
  }

  .dangerous {
    color: #ee7f01 !important;
    border-color: #ee7f01;
  }

  .divider-lift {
    background-color: #61bbc5 !important;
  }

  .divider-priority {
    background-color: #ea93fa !important;
  }

  .divider-heavy {
    background-color: #fbba00 !important;
  }

  .divider-dangerous {
    background-color: #ee7f01 !important;
  }

  .is-nob {
    background-color: lightcyan;
  }

  .v-data-table__mobile-table-row.is-nob td {
    background-color: lightcyan;
  }

  .is-extra {
    background-color: #d2bff0;
  }

  .v-data-table__mobile-table-row.is-extra td {
    background-color: #d2bff0;
  }
</style>
